<script setup>
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { supabase } from '@/supabase'

const store = useStore()
const aula = computed(() => store.state.aula)
const materialPesquisa = ref()
const carregando = ref(true)

onMounted(() => {
    listarConteudo()
})

async function listarConteudo() {
    store.dispatch('updateLoading', true)
    const { data, error } = await supabase
        .from('planos')
        .select('linkComOrientacoes')
        .eq('id', aula.value.idPlano)
    if(error){
        alert('Ocorreu um erro ao carregar o material de pesquisa: '+error)
        store.dispatch('updateLoading', false)
        return
    }
    materialPesquisa.value = data[0].linkComOrientacoes

    store.dispatch('updateLoading', false)
    carregando.value = false
}
</script>

<template>
    <div class="pt-8 container fadein animation-duration-500" v-if="!carregando">
        <a v-if="materialPesquisa != ''" target="_blank" class="card h-full shadow-1 hover:shadow-3 animation-duration-1000 cursor-pointer p-5 bg-white border-round-sm block no-underline" :href="materialPesquisa">
            <div class="flex align-items-center gap-3 ">
                <div class="pi pi-book text-2xl text-color-secondary"></div>
                <div class="flex align-items-center justify-content-between w-full">
                    <div class="font-semibold text-color text-xl">Material de pesquisa</div>
                </div>
                <div class="pi pi-external-link text-xl text-color-secondary"></div>
            </div>
        </a>
        <div v-else class="text-center text-color">
            O professor não anexou aqui nenhum material de pesquisa nesse plano
        </div>
    </div>
</template>